import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import {
  ArchiveBoxXMarkIcon,
  ChevronDownIcon,
  PencilIcon,
  Square2StackIcon,
  TrashIcon,
} from '@heroicons/react/16/solid'
import { BuildingLibraryIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { Fragment, useContext, useEffect, useState } from "react";
import { ArrowLeftIcon, CheckCircleIcon, PencilSquareIcon } from "@heroicons/react/20/solid";
import { AddBank } from "./AddBank";
import { OfertaViewContext } from "../../../../context/OfertaContext/OfertaViewContext";
import { APIClient } from "../../../../helpers/api_helper";
import { CHANGE_PRINCIPAL_BANK_ACCOUNT, DELETE_BANK_ACCOUNT } from "../../../../helpers/url_helper";
import { EditBank } from "./EditBank";

const apiClient = new APIClient();

export function ChangeBank() {
  const { updateMyBanks, myBanks } = useContext(OfertaViewContext);
  const [open, setOpen] = useState(false);
  const [myBankAccounts, setMyBankAccounts] = useState([]);
  const [openModalEditBank, setOpenModalEditBank] = useState(false);
  const [accountToEdit, setAccountToEdit] = useState({});

  useEffect(() => {
    setMyBankAccounts(myBanks?.myBankAccounts);
  }, [myBanks?.myBankAccounts, myBanks?.parentAccount]);

  /* useEffect(() => {
    setOpenModalEditBank(myBanks.openModalEditBank);
    setAccountToEdit(myBanks.accountToEdit);
  }, [myBanks.openModalEditBank]); */

  const handleAccountSelected = (account) => {
    apiClient.create(CHANGE_PRINCIPAL_BANK_ACCOUNT, { doc: localStorage.getItem("doc"), bankAccount: { ...account, parent: true } })
      .then((response) => console.log(response.statusText)).catch((error) => console.log(error));

    updateMyBanks({ ...myBanks, myBankAccounts: updateParentAccount(myBanks?.myBankAccounts, account?.id) });
  }

  const handleRemoveAccount = (account) => {
    updateMyBanks({ ...myBanks, myBankAccounts: removeAccount(myBanks?.myBankAccounts, account?.id) });
  };

  const handleEditAccount = (account) => {
    console.log('account', account);

    setOpenModalEditBank(true);
    setAccountToEdit(account);
  };

  function updateParentAccount(cuentas, nuevaCuentaPrincipalId) {
    // Encuentra la cuenta actualmente seleccionada como principal
    const cuentaActual = cuentas.find((cuenta) => cuenta.parent === true);

    // Si hay una cuenta actualmente seleccionada, actualiza su parent
    if (cuentaActual) {
      cuentaActual.parent = false;
    }

    // Actualiza la nueva cuenta seleccionada como principal
    const nuevaCuenta = cuentas.find((cuenta) => cuenta.id === nuevaCuentaPrincipalId);
    if (nuevaCuenta) {
      nuevaCuenta.parent = true;
    }

    // Devuelve el arreglo de cuentas bancarias actualizado
    return cuentas.map((cuenta) => ({
      id: cuenta.id,
      bankAccount: cuenta.bankAccount,
      typeBankAccount: cuenta.typeBankAccount,
      accountNumber: cuenta.accountNumber,
      parent: cuenta.parent,
      dateCreated: cuenta.dateCreated || cuenta.createdAt,
    }));
  }

  const removeAccount = (cuentas, idCuentaEliminar) => {
    apiClient.delete(`${DELETE_BANK_ACCOUNT}/${localStorage.getItem("doc")}/${idCuentaEliminar}`)
      .then((response) => console.log(response.statusText)).catch((error) => console.log(error));

    return cuentas.filter((cuenta) => cuenta.id !== idCuentaEliminar);
  };

  return (
    <>
      <div onClick={() => setOpen(true)}>
        <div className="cursor-pointer min-w-full">
          <div className="text-sm text-green font-bold">Cambiar</div>
        </div>
      </div>
      <Dialog open={open} onClose={setOpen} className="relative z-50">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-transparent transition-opacity duration-200 ease-in-out data-[closed]:opacity-0"
        />

        <div className="fixed inset-x-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed md:inset-y-0 bottom-0 md:right-0 flex max-w-full md:pl-10">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen md:max-w-sm transform h-128 md:h-full transition duration-300 ease-in-out data-[closed]:translate-x-full"
              >
                <div className="flex h-full flex-col rounded-t-3xl md:rounded-none bg-darkBg tracking-tight font-walsheim">
                  <div className="">
                    <div className="py-6">
                      <div className="flex justify-between px-4 pt-2 md:pt-8">
                        <div className="flex h-7 items-center">
                          <button
                            type="button"
                            onClick={() => setOpen(false)}
                            className="relative text-white focus:outline-none"
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <ArrowLeftIcon
                              aria-hidden="true"
                              className="h-6 w-6"
                            />
                          </button>
                        </div>
                        <DialogTitle>
                          <div className="text-white">Mis bancos</div>
                        </DialogTitle>
                        <div className="flex h-7 items-center">
                          <button
                            type="button"
                            onClick={() => setOpen(false)}
                            className="relative text-white focus:outline-none"
                          >
                            <span className="absolute" />
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                          </button>
                        </div>
                      </div>
                      <div className="pt-2 px-4 text-sm text-grayP">
                        Puedes guardar hasta (4) bancos para tus desembolsos
                      </div>
                    </div>
                  </div>
                  <div className="h-full p-4 rounded-t-3xl bg-purpleLight overflow-auto">
                    <div className="w-full flex justify-between">
                      <h2 className="text-grayP">Disponibles</h2>
                      <AddBank
                        setMyBankAccounts={setMyBankAccounts}
                      />
                      {
                        openModalEditBank && (
                          <EditBank open={openModalEditBank} setOpen={setOpenModalEditBank} accountToEdit={accountToEdit} />
                        )
                      }
                    </div>
                    <div className="bg-white rounded-3xl mt-4">
                      {
                        (myBankAccounts ?? []).map((account, index) => {
                          return (
                            <div className="w-full p-4 flex justify-between" key={'parent-' + index} >
                              <div className="flex gap-2 items-center">
                                <div className="w-10 h-10 rounded-full bg-purple grid content-center justify-items-center">
                                  <BuildingLibraryIcon className="w-8 h-auto text-white" />
                                </div>
                                <div className="text-sm">
                                  <div>{account?.bankAccount}</div>
                                  <div>{account?.typeBankAccount}</div>
                                  <div>{account?.accountNumber}</div>
                                </div>
                              </div>

                              {
                                account?.parent === true && (
                                  <Fragment key={account.id}>
                                    <div className="w-5 h-5 rounded-full bg-green ">
                                      <CheckCircleIcon color="white" />
                                      <div className="flex justify-end items-center cursor-pointer text-grayLight font-bold text-sm mt-3" onClick={() => handleEditAccount(account)}>
                                        Editar
                                      </div>
                                    </div>
                                  </Fragment>
                                )
                              }
                              {
                                account?.parent === false && (
                                  <div className="grid content-between">

                                    <div className="w-full flex justify-end">
                                      <div onClick={() => handleAccountSelected(account)} className="w-5 h-5 rounded-full border-2 border-grayP cursor-pointer"></div>
                                    </div>

                                    <div className="display-grid grid-cols-2 gap-2">

                                      <div onClick={() => handleRemoveAccount(account)}>
                                        <div className="cursor-pointer text-red font-bold text-sm mt-2">
                                          Borrar
                                        </div>
                                      </div>

                                      <div onClick={() => handleEditAccount(account)}>
                                        <div className="cursor-pointer text-grayLight font-bold text-sm mt-2">
                                          Editar
                                        </div>
                                      </div>

                                    </div>

                                  </div>

                                )
                              }
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
